export default __webpack_public_path__ + "static/media/NH02.84b90130.jpg";